/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './time';
import './number';
import '../common/countries';
import '../channels/channels';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "rolodexdiscovery": {
        "nested": {
          "service": {
            "nested": {
              "FilterConditions": {
                "fields": {
                  "all": {
                    "type": ".squareup.rolodexdiscovery.service.Filters",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "any": {
                    "type": ".squareup.rolodexdiscovery.service.Filters",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "none": {
                    "type": ".squareup.rolodexdiscovery.service.Filters",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "Filters": {
                "fields": {
                  "createdAt": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 2,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 16,
                    "rule": "optional"
                  },
                  "emails": {
                    "type": ".squareup.rolodexdiscovery.service.FilterEmail",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "phones": {
                    "type": ".squareup.rolodexdiscovery.service.FilterPhone",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "creationSource": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 3,
                    "rule": "optional"
                  },
                  "groups": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 4,
                    "rule": "optional"
                  },
                  "payments": {
                    "type": ".squareup.rolodexdiscovery.service.FilterPayment",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "customFields": {
                    "type": ".squareup.rolodexdiscovery.service.FilterCustomFieldValue",
                    "id": 6,
                    "keyType": "string"
                  },
                  "conversations": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConversation",
                    "id": 7,
                    "rule": "optional"
                  },
                  "reachable": {
                    "type": ".squareup.rolodexdiscovery.service.FilterReachable",
                    "id": 10,
                    "rule": "optional"
                  },
                  "cards": {
                    "type": ".squareup.rolodexdiscovery.service.FilterCard",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "loyalty": {
                    "type": ".squareup.rolodexdiscovery.service.FilterLoyalty",
                    "id": 14,
                    "rule": "optional"
                  },
                  "birthday": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 15,
                    "rule": "optional"
                  },
                  "has": {
                    "type": ".squareup.rolodexdiscovery.service.Fields",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "hasNot": {
                    "type": ".squareup.rolodexdiscovery.service.Fields",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "customAttributeFilter": {
                    "type": ".squareup.rolodexdiscovery.service.CustomAttributesFilter",
                    "id": 17,
                    "rule": "optional"
                  },
                  "booking": {
                    "type": ".squareup.rolodexdiscovery.service.FilterBooking",
                    "id": 18,
                    "rule": "optional"
                  },
                  "customerType": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 19,
                    "rule": "optional"
                  },
                  "cashBrandFollowing": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 20,
                    "rule": "optional"
                  }
                }
              },
              "FilterValue": {
                "fields": {
                  "all": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "any": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "none": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FilterText": {
                "fields": {
                  "exact": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fuzzy": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FilterEmail": {
                "fields": {
                  "type": {
                    "type": ".squareup.rolodexdiscovery.service.FilterEmail.Type",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "value": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PUBLIC": 1,
                      "PRIVATE": 2,
                      "NESTED": 3
                    }
                  }
                }
              },
              "FilterPhone": {
                "fields": {
                  "type": {
                    "type": ".squareup.rolodexdiscovery.service.FilterPhone.Type",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "value": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PUBLIC": 1,
                      "PRIVATE": 2,
                      "NESTED": 3
                    }
                  }
                }
              },
              "FilterCard": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.rolodexdiscovery.service.FilterCard.Type",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PUBLIC": 1,
                      "PRIVATE": 2
                    }
                  }
                }
              },
              "FilterPayment": {
                "fields": {
                  "date": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationTokens": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 4,
                    "rule": "optional"
                  },
                  "itemTokens": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 5,
                    "rule": "optional"
                  },
                  "itemCategoryTokens": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 6,
                    "rule": "optional"
                  },
                  "total": {
                    "type": ".squareup.rolodexdiscovery.service.NumberRange",
                    "id": 7,
                    "rule": "optional"
                  },
                  "salesChannels": {
                    "type": ".squareup.rolodexdiscovery.service.FilterChannel",
                    "id": 11,
                    "rule": "optional"
                  },
                  "count": {
                    "type": ".squareup.rolodexdiscovery.service.NumberRange",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalSum": {
                    "type": ".squareup.rolodexdiscovery.service.NumberRange",
                    "id": 8,
                    "rule": "optional"
                  },
                  "firstOccurred": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 9,
                    "rule": "optional"
                  },
                  "lastOccurred": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "FilterCustomFieldValue": {
                "fields": {
                  "boolValue": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "anyEnumValues": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "allEnumValues": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "emailValue": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phoneValue": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 5,
                    "rule": "optional"
                  },
                  "stringValue": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 6,
                    "rule": "optional"
                  },
                  "dateValue": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 7,
                    "rule": "optional"
                  },
                  "numberValue": {
                    "type": ".squareup.rolodexdiscovery.service.FloatNumberRange",
                    "id": 8,
                    "rule": "optional"
                  },
                  "addressValue": {
                    "type": ".squareup.rolodexdiscovery.service.FilterAddress",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "CustomAttributesFilter": {
                "fields": {
                  "attributeFilters": {
                    "type": ".squareup.rolodexdiscovery.service.AttributePropertyFilter",
                    "id": 1,
                    "keyType": "string"
                  }
                }
              },
              "AttributePropertyFilter": {
                "fields": {
                  "updatedAtFilter": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "valueFilter": {
                    "type": ".squareup.rolodexdiscovery.service.FilterCustomFieldValue",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FilterConversation": {
                "fields": {
                  "sentiment": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConversationSentiment",
                    "id": 1,
                    "rule": "optional"
                  },
                  "date": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FilterConversationSentiment": {
                "fields": {
                  "any": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConversationSentiment.Sentiment",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "all": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConversationSentiment.Sentiment",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "none": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConversationSentiment.Sentiment",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Sentiment": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NEGATIVE": 2,
                      "POSITIVE": 3,
                      "UNSET": 5
                    }
                  }
                }
              },
              "FilterReachable": {
                "fields": {
                  "channel": {
                    "type": ".squareup.rolodexdiscovery.service.FilterReachableChannel",
                    "id": 2,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payments": {
                    "type": ".squareup.rolodexdiscovery.service.FilterPayment",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FilterReachableChannel": {
                "values": {
                  "INVALID_REACHABLE_CHANNEL": 0,
                  "EMAIL": 1,
                  "PHONE": 2
                }
              },
              "Fields": {
                "values": {
                  "FIELDS_DO_NOT_USE": 0,
                  "FIELDS_FIRST_NAME": 100,
                  "FIELDS_LAST_NAME": 101,
                  "FIELDS_PHONES": 102,
                  "FIELDS_EMAILS": 103,
                  "FIELDS_CARDS": 104,
                  "FIELDS_GROUPS": 105,
                  "FIELDS_BIRTHDAY": 106,
                  "FIELDS_REFERENCE_ID": 107,
                  "FIELDS_COMPANY_NAME": 108,
                  "FIELDS_CONVERSATIONS": 109,
                  "FIELDS_LOYALTY": 110,
                  "FIELDS_CUSTOMER_BALANCE_ACCOUNTS": 111,
                  "FIELDS_CASH_BRAND_FOLLOWING": 112
                }
              },
              "FilterLoyalty": {
                "fields": {
                  "phone": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pointBalance": {
                    "type": ".squareup.rolodexdiscovery.service.NumberRange",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enrolledAt": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tierBenefitPackageId": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FilterAddress": {
                "fields": {
                  "postalCode": {
                    "type": ".squareup.rolodexdiscovery.service.FilterText",
                    "id": 1,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FilterBooking": {
                "fields": {
                  "latestActiveBookingStartAt": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recurringBookingStatus": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 2,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": ".squareup.rolodexdiscovery.service.TimeRange",
                    "id": 3,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isFirst": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isLast": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 7,
                    "rule": "optional"
                  },
                  "serviceId": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 8,
                    "rule": "optional"
                  },
                  "serviceVariationId": {
                    "type": ".squareup.rolodexdiscovery.service.FilterValue",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "FilterChannel": {
                "fields": {
                  "any": {
                    "type": ".squareup.rolodexdiscovery.service.FilterChannel.Channel",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "none": {
                    "type": ".squareup.rolodexdiscovery.service.FilterChannel.Channel",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Channel": {
                    "fields": {
                      "referenceType": {
                        "type": ".squareup.channels.Reference.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "channelId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterConditions && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.Filters && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterValue && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterText && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterEmail && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterEmail?.nested?.Type && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterPhone && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterPhone?.nested?.Type && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterCard && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterCard?.nested?.Type && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterPayment && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterCustomFieldValue && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.CustomAttributesFilter && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.AttributePropertyFilter && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterConversation && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterConversationSentiment && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterConversationSentiment?.nested?.Sentiment && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterReachable && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterReachableChannel && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.Fields && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterLoyalty && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterAddress && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterBooking && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterChannel && !$root.nested?.squareup?.nested?.rolodexdiscovery?.nested?.service?.nested?.FilterChannel?.nested?.Channel) {
  $root.addJSON(jsonData);
}

/**
 * Represent conditions applicable to a search. Conditions express inclusion (`any`),
 * intersection (`all`), and exclusion (`none`).
 *
 * SOURCE FilterConditions @ squareup/rolodexdiscovery/filters.proto at 16:1
 */
export const FilterConditions = $root.lookupType('squareup.rolodexdiscovery.service.FilterConditions');
fixType(FilterConditions);
Builder.createAndAttachToType(FilterConditions);
/**
 * Represents the filters to apply to the customer search.
 *
 * SOURCE Filters @ squareup/rolodexdiscovery/filters.proto at 28:1
 */
export const Filters = $root.lookupType('squareup.rolodexdiscovery.service.Filters');
fixType(Filters);
Builder.createAndAttachToType(Filters);
/**
 * A filter to select customers based on an exact field value. For any given
 * value, the value can only be in one property. Depending on the field, either
 * all properties can be set or only a subset will be available. Refer to the
 * documentation of the field.
 *
 * SOURCE FilterValue @ squareup/rolodexdiscovery/filters.proto at 109:1
 */
export const FilterValue = $root.lookupType('squareup.rolodexdiscovery.service.FilterValue');
fixType(FilterValue);
Builder.createAndAttachToType(FilterValue);
/**
 * A filter to select customers where a given field is either a partial match or an exact match. For
 * partial matches, you can use the `match` property, for exact matches (case sensitivity depends
 * on the field), use `exact`. Only one of the field can be set.
 *
 * SOURCE FilterText @ squareup/rolodexdiscovery/filters.proto at 126:1
 */
export const FilterText = $root.lookupType('squareup.rolodexdiscovery.service.FilterText');
fixType(FilterText);
Builder.createAndAttachToType(FilterText);
/**
 * A filter to select customers based on their email address. The customer has 3 types of email
 * addresses: public (visible to the seller in dashboard), private (invisible to seller but used by
 * tools like marketing), and nested (visible to the seller in dashboard but listed under another
 * application such as loyalty).
 *
 * SOURCE FilterEmail @ squareup/rolodexdiscovery/filters.proto at 138:1
 */
export const FilterEmail = $root.lookupType('squareup.rolodexdiscovery.service.FilterEmail');
fixType(FilterEmail);
Builder.createAndAttachToType(FilterEmail);
/**
 * SOURCE Type @ squareup/rolodexdiscovery/filters.proto at 139:3
 */
FilterEmail.Type = $root.lookupEnum('squareup.rolodexdiscovery.service.FilterEmail.Type').values;
/**
 * A filter to select customers based on their phone number. The customer has 3 types of phone
 * numbers: public (visible to the seller in dashboard), private (invisible to seller but used by
 * tools like marketing), and nested (visible to the seller in dashboard but listed under another
 * application such as loyalty).
 *
 * SOURCE FilterPhone @ squareup/rolodexdiscovery/filters.proto at 167:1
 */
export const FilterPhone = $root.lookupType('squareup.rolodexdiscovery.service.FilterPhone');
fixType(FilterPhone);
Builder.createAndAttachToType(FilterPhone);
/**
 * SOURCE Type @ squareup/rolodexdiscovery/filters.proto at 168:3
 */
FilterPhone.Type = $root.lookupEnum('squareup.rolodexdiscovery.service.FilterPhone.Type').values;
/**
 * A filter to select customers based on card information. The card is represented by a token and
 * by a type. Internal consumers can request customers who have a fidelius token that is either
 * public or private; for public consumers (e.g. api), only searches on public card tokens is
 * allowed.
 *
 * SOURCE FilterCard @ squareup/rolodexdiscovery/filters.proto at 196:1
 */
export const FilterCard = $root.lookupType('squareup.rolodexdiscovery.service.FilterCard');
fixType(FilterCard);
Builder.createAndAttachToType(FilterCard);
/**
 * SOURCE Type @ squareup/rolodexdiscovery/filters.proto at 197:3
 */
FilterCard.Type = $root.lookupEnum('squareup.rolodexdiscovery.service.FilterCard.Type').values;
/**
 * A filter to select customers based on payment information. For negative operations (when no
 * payments have occurred), set the max on the `count` to 0.
 *
 * The fields in this message are broken into two types:
 *
 *  1. Individual Payment Filters
 *     Filters on each Payment in a Customer's Payment history, trimming the set of payments
 *     to only payments for which all of the specified filters hold true.
 *  2. Aggregation Filters
 *     After filtering Payments using any/all of the Individual Payment Filters, apply further
 *     filters on the aggregation over all of the resulting set of Payments.
 *
 * SOURCE FilterPayment @ squareup/rolodexdiscovery/filters.proto at 225:1
 */
export const FilterPayment = $root.lookupType('squareup.rolodexdiscovery.service.FilterPayment');
fixType(FilterPayment);
Builder.createAndAttachToType(FilterPayment);
/**
 * A filter to select customers based on custom field data. Today, we only
 * expose searching on custom fields that are of type enum, bool, email, phone, text, or number.
 * This model will be expanded in the future to search on other types of data (such as addresses).
 *
 * SOURCE FilterCustomFieldValue @ squareup/rolodexdiscovery/filters.proto at 311:1
 */
export const FilterCustomFieldValue = $root.lookupType('squareup.rolodexdiscovery.service.FilterCustomFieldValue');
fixType(FilterCustomFieldValue);
Builder.createAndAttachToType(FilterCustomFieldValue);
/**
 * Filter customers based on their custom attributes.
 *
 * SOURCE CustomAttributesFilter @ squareup/rolodexdiscovery/filters.proto at 346:1
 */
export const CustomAttributesFilter = $root.lookupType('squareup.rolodexdiscovery.service.CustomAttributesFilter');
fixType(CustomAttributesFilter);
Builder.createAndAttachToType(CustomAttributesFilter);
/**
 * Filter a single attribute based on its value or metadata.
 *
 * SOURCE AttributePropertyFilter @ squareup/rolodexdiscovery/filters.proto at 351:1
 */
export const AttributePropertyFilter = $root.lookupType('squareup.rolodexdiscovery.service.AttributePropertyFilter');
fixType(AttributePropertyFilter);
Builder.createAndAttachToType(AttributePropertyFilter);
/**
 * A filter to select customers based on the conversations they have sent. Having
 * a more advanced structure enables us to do more types of queries in the future
 * such as finding customers who have left a negative conversation in the past 5 days.
 *
 * SOURCE FilterConversation @ squareup/rolodexdiscovery/filters.proto at 362:1
 */
export const FilterConversation = $root.lookupType('squareup.rolodexdiscovery.service.FilterConversation');
fixType(FilterConversation);
Builder.createAndAttachToType(FilterConversation);
/**
 * FilterConversationSentiment is similar to FilterValue: it helps reduce the list of customers to
 * customers who have provided a conversation with a specific sentiment. A conversation has 3
 * different sentiments: it can be negative, positive or unset (different from neutral, in case we
 * support this in future generations.
 *
 * SOURCE FilterConversationSentiment @ squareup/rolodexdiscovery/filters.proto at 374:1
 */
export const FilterConversationSentiment = $root.lookupType('squareup.rolodexdiscovery.service.FilterConversationSentiment');
fixType(FilterConversationSentiment);
Builder.createAndAttachToType(FilterConversationSentiment);
/**
 * SOURCE Sentiment @ squareup/rolodexdiscovery/filters.proto at 375:3
 */
FilterConversationSentiment.Sentiment = $root.lookupEnum('squareup.rolodexdiscovery.service.FilterConversationSentiment.Sentiment').values;
/**
 * A filter to select customers that are reachable. The reachable filters work by
 * finding all customers that have email addresses (including privates) and have
 * made either a minimum number of payments or are not instant profiles.
 *
 * SOURCE FilterReachable @ squareup/rolodexdiscovery/filters.proto at 406:1
 */
export const FilterReachable = $root.lookupType('squareup.rolodexdiscovery.service.FilterReachable');
fixType(FilterReachable);
Builder.createAndAttachToType(FilterReachable);
/**
 * Represents the reachable filter channels.
 *
 * SOURCE FilterReachableChannel @ squareup/rolodexdiscovery/filters.proto at 423:1
 */
export const FilterReachableChannel = $root.lookupEnum('squareup.rolodexdiscovery.service.FilterReachableChannel').values;
/**
 * A list of fields that can be checked for presence / absence.
 *
 * SOURCE Fields @ squareup/rolodexdiscovery/filters.proto at 435:1
 */
export const Fields = $root.lookupEnum('squareup.rolodexdiscovery.service.Fields').values;
/**
 * A filter to select customers based on their loyalty activity, such as
 * a point balance, an associated phone number, and/or an enrollment date.
 *
 * SOURCE FilterLoyalty @ squareup/rolodexdiscovery/filters.proto at 455:1
 */
export const FilterLoyalty = $root.lookupType('squareup.rolodexdiscovery.service.FilterLoyalty');
fixType(FilterLoyalty);
Builder.createAndAttachToType(FilterLoyalty);
/**
 * A customer address to search for
 *
 * SOURCE FilterAddress @ squareup/rolodexdiscovery/filters.proto at 473:1
 */
export const FilterAddress = $root.lookupType('squareup.rolodexdiscovery.service.FilterAddress');
fixType(FilterAddress);
Builder.createAndAttachToType(FilterAddress);
/**
 * A filter to select customers based on booking information.
 *
 * SOURCE FilterBooking @ squareup/rolodexdiscovery/filters.proto at 482:1
 */
export const FilterBooking = $root.lookupType('squareup.rolodexdiscovery.service.FilterBooking');
fixType(FilterBooking);
Builder.createAndAttachToType(FilterBooking);
/**
 * A filter to select customers based on the channel data on its payments.
 *
 * SOURCE FilterChannel @ squareup/rolodexdiscovery/filters.proto at 523:1
 */
export const FilterChannel = $root.lookupType('squareup.rolodexdiscovery.service.FilterChannel');
fixType(FilterChannel);
Builder.createAndAttachToType(FilterChannel);
/**
 * A channel object to contain relevant fields used in the filter.
 *
 * SOURCE Channel @ squareup/rolodexdiscovery/filters.proto at 525:3
 */
FilterChannel.Channel = $root.lookupType('squareup.rolodexdiscovery.service.FilterChannel.Channel');
fixType(FilterChannel.Channel);
Builder.createAndAttachToType(FilterChannel.Channel);